<div class="selectable-container">
	@for (status of statuses; track status) {
		<div
			(click)="selectStatus(status)"
			[class.selected]="status.value === selectedStatus"
			class="selectable-item"
		>
			{{ status.key | translate }}
		</div>
	}
</div>
